import React from "react"

/* Import Local Style(s) */
import "./search.scss"

const Search = ({ handleChange, value, placeholder = '' }) => {
  const handleSubmit = event => {
    event.preventDefault()
  }

  const p = (placeholder !== '') ? placeholder : 'Search'

  return (
    <form className="search" onSubmit={handleSubmit}>
      <input
        placeholder={p}
        type="text"
        value={value}
        onChange={handleChange}
      />
    </form>
  )
}

export default Search
